<dodo-info-dialog-layout (close)="closeDialog()">
	<div class="header" header>
		<div class="title" [innerHTML]="title"></div>
	</div>
	<div class="content" content>
		<div class="info">
			<div class="div-gap bottom" [innerHTML]="errorMessageLine1"></div>
		</div>
		<div class="info">
			<div class="div-gap bottom" [innerHTML]="errorMessageLine2"></div>
		</div>
		<div class="actions">
			<dodo-raised-button (clicked)="closeDialog()" color="primary">
				Continue
			</dodo-raised-button>
		</div>
	</div>
</dodo-info-dialog-layout>
